import { Container } from "react-bootstrap";
import ProjetosferaLogo from "assets/logos/projetosfera-logo.svg";
import style from "./login.module.css";
import LoginForm from "components/forms/login-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { useEffect } from "react";
import useUuidStorage from "hooks/useUuidStorage";
import useEventIdStorage from "hooks/useEventIdStorage"

const ENDPOINT = process.env.REACT_APP_API_URL;

const Login = () => {

    const navigate = useNavigate();
    const {eventId} = useParams();

    const {getUuid} = useUuidStorage();
    const {getEventId, saveEventId} = useEventIdStorage();

    useEffect(()=>{
        const uuid = getUuid();
        const storedEventId = getEventId();

        if(!uuid) return;

        navigate(`/avaliacao/${storedEventId}/${uuid}/menu`);
    }, []);

    const onLoginSuccess = ({ data, uuidStr, eventId }) => {
        // Salvar event_id no localStorage para acessar depois
        saveEventId(eventId);
        
        const evaluationUrl = `/avaliacao/${eventId}/${uuidStr}/menu`;

        navigate(evaluationUrl);
    }

    const onLoginError = () => toast.error("Não foi possível autêntica-lo. Por favor, verifique o código e o captcha informado.")

    const eventLogoUrl = eventId
        ? `${ENDPOINT}/api/events/${eventId}/logo`
        : ProjetosferaLogo;
    
    return (
        <section className="bg-dark-blue h-100 ">
            <Container className="d-flex h-100 flex-column justify-content-center align-items-center">
                <div className="mb-5">
                    <img
                        className={`w-100 ${style.projetosfera_logo}`}
                        src={eventLogoUrl}
                        alt="Logo da Feira Brasileira de Ciências e Engenharias"
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = ProjetosferaLogo;
                        }}
                    />
                    <h1 className="text-center mt-2 text-dark font-weight-bold">
                        Avaliação
                    </h1>
                </div>

                <LoginForm
                    onLoginError={onLoginError}
                    onLoginSuccess={onLoginSuccess}
                />
            </Container>
        </section>
    )
}

export default Login;